// Tracks "is this the user's first visit ever?" — used by the boot
// flow to pick which entrance video to play. Persisted in localStorage
// so it survives across sessions; private-browsing falls back to
// "first visit" every time, which is acceptable for an entrance video.

const VISIT_KEY = 'smp.hasVisitedV1';

export function isFirstEverVisit(): boolean {
  try {
    return localStorage.getItem(VISIT_KEY) !== '1';
  } catch {
    return true;
  }
}

// Mark this device as having visited at least once. Idempotent.
// Called once per cold boot from main.ts so the next boot picks the
// "returning player" entrance video.
export function markVisited(): void {
  try {
    localStorage.setItem(VISIT_KEY, '1');
  } catch {
    /* private browsing — visit count won't persist, that's fine */
  }
}
